<template>
  <div>
    <!-- Modal de Formulario de Registro -->
    <div v-if="modelValue && !mostrarModalExito" class="modal-overlay">
      <div class="modal-content scrollable">
        <h2 class="modal-title">Registro de Empresa</h2>
        <div class="modal-sections">
          <!-- Sección 1: Datos de la Empresa -->
          <section class="modal-section">
            <h3>Datos de la Empresa</h3>
            <span class="error-msg">(*) datos Obligatorios</span>
            
            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <select v-model="form.rubro">
                <option disabled value="0">Seleccione un rubro</option>
                <option
                  v-for="rubro in rubros"
                  :key="rubro.idRubro"
                  :value="rubro.idRubro"
                >
                  {{ rubro.nombre }}
                </option>
              </select>
            </div>
            <span v-if="errores.rubro" class="error-msg">{{ errores.rubro }}</span>

            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="Nombre de la Empresa" v-model="form.nombre" />
            </div>
            <span v-if="errores.nombre" class="error-msg">{{ errores.nombre }}</span>

            <div class="input-wrapper">
              <input type="text" placeholder="NIT o CI" v-model="form.nit" style="margin-left: 14px; width: calc(100% - 14px);" />
            </div>

            <div class="input-wrapper">
              <input type="text" placeholder="Página Web (Opcional)" v-model="form.pagina" style="margin-left: 14px; width: calc(100% - 14px);" />
            </div>

            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="País" v-model="form.pais" />
            </div>
            <span v-if="errores.pais" class="error-msg">{{ errores.pais }}</span>

            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="Ciudad/Localidad" v-model="form.ciudad" />
            </div>
            <span v-if="errores.ciudad" class="error-msg">{{ errores.ciudad }}</span>

            <div class="input-wrapper">
              <input type="text" placeholder="Dirección" v-model="form.direccion" style="margin-left: 14px; width: calc(100% - 14px);" />
            </div>

            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="Teléfono o Celular" v-model="form.celular" />
            </div>
            <span v-if="errores.celular" class="error-msg">{{ errores.celular }}</span>
          </section>

          <!-- Sección 2: Cuenta de Acceso -->
          <section class="modal-section">
            <h3>Cuenta de Acceso</h3>
            <p class="subtext">
              El acceso será tu primer nombre en minúsculas + número de carnet y la
              contraseña será el número de carnet
            </p>
            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="Nombres" v-model="form.u1_nombre" />
            </div>
            <span v-if="errores.u1_nombre" class="error-msg">{{ errores.u1_nombre }}</span>

            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="Apellidos" v-model="form.u1_apellido" />
            </div>
            <span v-if="errores.u1_apellido" class="error-msg">{{ errores.u1_apellido }}</span>

            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="Número de carnet (Esta será tu contraseña)" v-model="form.u1_carnet" />
            </div>
            <span v-if="errores.u1_carnet" class="error-msg">{{ errores.u1_carnet }}</span>

            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="Celular" v-model="form.u1_celular" />
            </div>
            <span v-if="errores.u1_celular" class="error-msg">{{ errores.u1_celular }}</span>

            <div class="input-wrapper">
              <span class="required-symbol">*</span>
              <input type="text" placeholder="Cargo en la Empresa" v-model="form.u1_cargo" />
            </div>
            <span v-if="errores.u1_cargo" class="error-msg">{{ errores.u1_cargo }}</span>

            <div class="input-wrapper">
              <input type="email" placeholder="Correo Electrónico (Opcional)" v-model="form.u1_correo" style="margin-left: 14px; width: calc(100% - 14px);" />
            </div>
          </section>

          <!-- Sección 3: Participante adicional -->
          <section class="modal-section full-width">
            <h3>Registrar participante adicional (Opcional)</h3>
            <div class="grid-2-cols">
              <input type="text" placeholder="Nombres" v-model="form.u2_nombre" />
              <input type="text" placeholder="Apellidos" v-model="form.u2_apellido" />
              <input type="text" placeholder="Carnet" v-model="form.u2_carnet" />
              <input type="text" placeholder="Celular" v-model="form.u2_celular" />
              <input type="text" placeholder="Cargo" v-model="form.u2_cargo" />
            </div>
          </section>
        </div>

        <!-- Botones de acción -->
        <div class="modal-actions">
          <button @click="registrarEmpresa" class="registrar-final" :disabled="!isFormValid || cargando">
            <span v-if="cargando">Registrando...</span>
            <span v-else>Registrar Empresa/Usuarios</span>
          </button>
          <button @click="cerrar" class="cancelar-btn" :disabled="cargando">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal de Éxito -->
    <div v-if="mostrarModalExito" class="modal-overlay" style="z-index: 2000;">
      <div class="modal-content success-modal">
        <h2 class="modal-title" style="color: #2ecc71;">¡Empresa registrada exitosamente!</h2>
        <h2 class="modal-title" style="color: #2ecc71;">Sus credenciales para ingresar son: </h2>
        <div class="credenciales-box">
          <p><strong>Usuario:</strong> {{ credencialesGeneradas.usuario }}</p>
          <p><strong>Contraseña:</strong> {{ credencialesGeneradas.contrasena }}</p>
        </div>
        <button @click="finalizarExito" class="btn btn-aceptar" style="width: auto; padding: 0.8rem 2rem; margin-top: 1.5rem; align-self: center;">
          Aceptar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, computed, onMounted, defineProps, defineEmits } from "vue";
import { getRubros, createEmpresa } from "@/services";

defineProps({
  modelValue: Boolean
});

const emit = defineEmits(["update:modelValue", "guardado"]);

const rubros = ref([]);
const cargando = ref(false);
const mostrarModalExito = ref(false);

const credencialesGeneradas = reactive({
  usuario: "",
  contrasena: ""
});

const form = reactive({
  nombre: null,
  nit: null,
  celular: null,
  rubro: 0,
  numeroParticipantes: 1,
  habilitado: true,
  pais: null,
  ciudad: null,
  direccion: null,
  fechaRegistro: new Date(),
  u1_nombre: null,
  u2_nombre: null,
  u1_apellido: null,
  u2_apellido: null,
  u1_celular: null,
  u2_celular: null,
  u1_correo: null,
  u1_carnet: null,
  u2_carnet: null,
  u1_cargo: null,
  u2_cargo: null,
});

const errores = reactive({
  rubro: "",
  nombre: "",
  pais: "",
  ciudad: "",
  celular: "",
  u1_nombre: "",
  u1_apellido: "",
  u1_carnet: "",
  u1_celular: "",
  u1_cargo: "",
});

// Validaciones
watch(() => form.rubro, (v) => errores.rubro = v ? "" : "Este campo es requerido");
watch(() => form.nombre, (v) => errores.nombre = v ? "" : "Este campo es requerido");
watch(() => form.pais, (v) => errores.pais = v ? "" : "Este campo es requerido");
watch(() => form.ciudad, (v) => errores.ciudad = v ? "" : "Este campo es requerido");
watch(() => form.celular, (v) => errores.celular = v ? "" : "Este campo es requerido");
watch(() => form.u1_nombre, (v) => errores.u1_nombre = v ? "" : "Este campo es requerido");
watch(() => form.u1_apellido, (v) => errores.u1_apellido = v ? "" : "Este campo es requerido");
watch(() => form.u1_carnet, (v) => errores.u1_carnet = v ? "" : "Este campo es requerido");
watch(() => form.u1_celular, (v) => errores.u1_celular = v ? "" : "Este campo es requerido");
watch(() => form.u1_cargo, (v) => errores.u1_cargo = v ? "" : "Este campo es requerido");

const isFormValid = computed(() => {
  return (
    form.rubro &&
    form.nombre &&
    form.pais &&
    form.ciudad &&
    form.celular &&
    form.u1_nombre &&
    form.u1_apellido &&
    form.u1_carnet &&
    form.u1_celular &&
    form.u1_cargo
  );
});

const limpiarFormulario = () => {
  Object.keys(form).forEach(key => {
    form[key] = (key === 'rubro') ? 0 : null;
  });
  form.numeroParticipantes = 1;
  form.habilitado = true;
  form.fechaRegistro = new Date();
};

const prepararDatos = () => {
  const {
    u1_nombre, u1_apellido, u1_celular, u1_correo, u1_carnet, u1_cargo,
    u2_nombre, u2_apellido, u2_celular, u2_correo, u2_carnet, u2_cargo,
    ...empresaBase
  } = form;

  const usuario = {
    nombre: u1_nombre, apellido: u1_apellido, celular: u1_celular,
    correo: u1_correo, carnet: u1_carnet, cargo: u1_cargo,
  };

  const datos = { ...empresaBase, usuario };

  if (u2_nombre || u2_apellido || u2_celular || u2_correo || u2_carnet || u2_cargo) {
    datos.usuarioSecundario = {
      nombre: u2_nombre, apellido: u2_apellido, celular: u2_celular,
      correo: u2_correo, carnet: u2_carnet, cargo: u2_cargo,
    };
  }
  return datos;
};

const registrarEmpresa = async () => {
  if (!isFormValid.value) return;
  
  cargando.value = true;
  const datos = prepararDatos();
  try {
    await createEmpresa(datos);
    
    // Generar credenciales
    const primerNombre = form.u1_nombre?.split(' ')[0]?.toLowerCase() || 'usuario';
    credencialesGeneradas.usuario = `${primerNombre}${form.u1_carnet}`;
    credencialesGeneradas.contrasena = form.u1_carnet;

    mostrarModalExito.value = true;
    limpiarFormulario();
  } catch (error) {
    alert("Error al registrar la empresa: " + (error?.response?.data?.error || "Error desconocido"));
  } finally {
    cargando.value = false;
  }
};

const cerrar = () => {
  emit("update:modelValue", false);
};

const finalizarExito = () => {
  mostrarModalExito.value = false;
  emit("guardado");
  cerrar();
};

onMounted(async () => {
  rubros.value = await getRubros();
  console.log(rubros);
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 2rem;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  width: 95%;
  max-width: 900px;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

.scrollable {
  overflow-y: auto;
}

.modal-title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
}

.modal-sections {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.modal-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.full-width {
  grid-column: 1 / -1;
}

.grid-2-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.subtext {
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 0.5rem;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.required-symbol {
  color: #e74c3c;
  font-weight: bold;
  font-size: 1.2rem;
  margin-right: 5px;
  line-height: 1;
}

.modal-section input,
.modal-section select {
  flex: 1;
  padding: 0.6rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  width: 100%;
}

.error-msg {
  color: #e74c3c;
  font-size: 0.8rem;
  margin-top: -4px;
  display: block;
}

.modal-actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}

.registrar-final {
  background-color: #2ecc71;
  color: white;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: opacity 0.3s;
}

.registrar-final:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cancelar-btn {
  background-color: #e74c3c;
  color: white;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
}

.success-modal {
  align-items: center;
  text-align: center;
  max-width: 500px;
}

.credenciales-box {
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  padding: 1.5rem;
  width: 100%;
  margin-top: 1rem;
}

.credenciales-box p {
  font-size: 1.2rem;
  margin: 0.5rem 0;
  color: #166534;
}

.btn-aceptar {
  background-color: #2ecc71;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
}
</style>
